import { CaracteristicaComValor } from "@/components/AtributoComValor"
import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"

export function usarAtributosComValor() {
  const { pegarSomenteData, pegarHorasMinutosSegundos } = usarDataHora()

  const buscarCaracteristicaPorTipoDeValor = (
    caracteristicas: CaracteristicaComValor[],
    tipoDeValor: string
  ) => {
    return caracteristicas.filter(
      (caracteristica) => caracteristica.tipoDoValor === tipoDeValor
    )
  }

  const converterOsValoresDataHoraParaString = (
    caracteristicas: CaracteristicaComValor[]
  ) => {
    const caracteristicasDoTipoData = buscarCaracteristicaPorTipoDeValor(
      caracteristicas,
      "data"
    )
    const caracteristicasDoTipoHorario = buscarCaracteristicaPorTipoDeValor(
      caracteristicas,
      "horario"
    )

    if (caracteristicasDoTipoData.length !== 0) {
      for (const caracteristica of caracteristicasDoTipoData) {
        caracteristica.valor = pegarSomenteData(caracteristica.valor as Date)
      }
    }
    if (caracteristicasDoTipoHorario.length !== 0) {
      for (const caracteristica of caracteristicasDoTipoHorario) {
        caracteristica.valor = pegarHorasMinutosSegundos(
          caracteristica.valor as Date
        )
      }
    }
    return caracteristicas
  }

  return {
    buscarCaracteristicaPorTipoDeValor,
    converterOsValoresDataHoraParaString,
  }
}
